document.addEventListener(
	"click",
	function (event) {
		// Only fire if the target has id copy
		if (!event.target.matches("#copy")) {
			return;
		}

		if (!navigator.clipboard) {
			// Clipboard API not available
			return;
		}
		const text = event.target.value;
		try {
			navigator.clipboard.writeText(text);
			document.getElementById("copy-status").innerText = "Copied to clipboard";
			setTimeout(function () {
				document.getElementById("copy-status").innerText = "";
			}, 1200);
		} catch (err) {

		}
	},
	false
);